import React from "react";
import { BookOpen, BookMarked, Check } from "lucide-react";
import { stripMemoryLabel } from "../../../lib/sabbathSchool";

function SpiritualGrowthCard({
  reading,
  read,
  lessonRead,
  markReadingDone,
  markLessonDone,
  lesson,
  quarterEnded,
}) {
  return (
    <div className="px-4">
      <div className="rounded-[20px] overflow-hidden bg-white dark:bg-slate-800 border border-slate-100 dark:border-slate-700/60 shadow-card">

        {/* ── REAVIVADOS ─────────────────────────────────── */}
        <div className="flex items-center gap-3.5 px-4 pt-4 pb-3.5">

          <div className="h-10 w-10 rounded-[12px] bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800/30 flex items-center justify-center shrink-0">
            <BookOpen size={17} className="text-blue-600 dark:text-blue-400" />
          </div>

          <div className="flex-1 min-w-0">
            <p className="text-[9px] font-medium uppercase tracking-[0.12em] text-slate-400 dark:text-slate-500 whitespace-nowrap">
              Reavivados por Su Palabra
            </p>
            <p className="mt-0.5 text-[14px] font-semibold leading-snug text-slate-800 dark:text-slate-100 truncate">
              {reading.book} {reading.chapter}
            </p>
          </div>

          <button
            onClick={markReadingDone}
            disabled={read}
            className={`
              shrink-0 flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-[11px] font-semibold
              transition-all duration-200 ease-out active:scale-[0.98]
              ${read
                ? "bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400"
                : "bg-[#1b4f9c] text-white shadow-sm hover:bg-[#0f3880]"}
            `}
          >
            {read ? <><Check size={11} strokeWidth={2.5} /> Leído</> : "Marcar"}
          </button>

        </div>

        {/* ── DIVIDER ─────────────────────────────────────── */}
        <div className="h-px bg-slate-100 dark:bg-slate-700/40 mx-4" />

        {/* ── ESCUELA SABÁTICA ────────────────────────────── */}
        <div className="px-4 pt-3.5 pb-3.5">
          <div className="flex items-start gap-3.5">

            <div className="h-10 w-10 rounded-[12px] bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-100 dark:border-indigo-800/30 flex items-center justify-center shrink-0 mt-0.5">
              <BookMarked size={17} className="text-indigo-600 dark:text-indigo-400" />
            </div>

            <div className="flex-1 min-w-0">
              <p className="text-[9px] font-medium uppercase tracking-[0.12em] text-slate-400 dark:text-slate-500 truncate">
                {quarterEnded
                  ? "Escuela Sabática"
                  : lesson
                  ? `Escuela Sabática · Sem. ${lesson.weekNumber} de ${lesson.totalWeeks}`
                  : "Escuela Sabática"}
              </p>

              {quarterEnded ? (
                <p className="mt-0.5 text-[14px] font-medium leading-snug text-slate-500 dark:text-slate-400">
                  Próximo trimestre disponible pronto
                </p>
              ) : lesson ? (
                <>
                  {/* Protagonista: título del DÍA (fallback al semanal si no hay día) */}
                  <p className="mt-0.5 text-[14px] font-semibold leading-snug text-slate-800 dark:text-slate-100 truncate">
                    {lesson.lessonTitle || lesson.weekTitle || "—"}
                  </p>
                  {/* Contexto: título SEMANAL en pequeño (solo si el protagonista es el del día) */}
                  {lesson.lessonTitle && lesson.weekTitle && (
                    <p className="mt-0.5 text-[11px] font-medium text-slate-500 dark:text-slate-400 truncate">
                      {lesson.weekTitle}
                    </p>
                  )}
                  {lesson.quarterTitle && (
                    <p className="mt-0.5 text-[10px] text-slate-400 dark:text-slate-500 truncate">
                      {lesson.quarterTitle}
                    </p>
                  )}
                </>
              ) : (
                <p className="mt-0.5 text-[15px] font-semibold leading-snug text-slate-400 dark:text-slate-500">
                  Cargando…
                </p>
              )}
            </div>

            {!quarterEnded && (
              <button
                onClick={markLessonDone}
                disabled={lessonRead}
                className={`
                  shrink-0 flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-[11px] font-semibold mt-0.5
                  transition-all duration-200 ease-out active:scale-[0.98]
                  ${lessonRead
                    ? "bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400"
                    : "bg-[#1b4f9c] text-white shadow-sm hover:bg-[#0f3880]"}
                `}
              >
                {lessonRead ? <><Check size={11} strokeWidth={2.5} /> Listo</> : "Marcar"}
              </button>
            )}

          </div>
        </div>

        {/* ── VERSÍCULO DE MEMORIA ─────────────────────────── */}
        {!quarterEnded && lesson?.verseText && (
          <>
            <div className="h-px bg-slate-100 dark:bg-slate-700/40 mx-4" />
            <div className="px-4 pt-3.5 pb-4">
              <p className="text-[9px] uppercase tracking-[0.12em] text-slate-400 dark:text-slate-500 font-medium mb-2 whitespace-nowrap">
                Versículo para memorizar
              </p>
              <p className="text-[13px] font-light italic leading-[1.85] text-slate-600 dark:text-slate-300">
                {stripMemoryLabel(lesson.verseText)}
              </p>
              {lesson.verseReference && (
                <p className="mt-2 text-[10px] uppercase tracking-[0.16em] text-slate-400 dark:text-slate-500">
                  — {lesson.verseReference}
                </p>
              )}
            </div>
          </>
        )}

      </div>
    </div>
  );
}

export default React.memo(SpiritualGrowthCard);
